const DATE_REGEX = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?$/

export const isDateString = (value: unknown): value is string => {
  if (value == null || typeof value !== 'string') {
    return false
  }
  return DATE_REGEX.test(value)
}
